import * as React from "react";

/**
 * Striped placeholder for video, poster frames and meeting thumbnails. Swap the background for a real <video>/<img>; overlays (scrim, play button, badges) go in children.
 */
export interface VideoFrameProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string;
  tone?: "light" | "meeting" | "dark";
  /** CSS aspect-ratio, default "16 / 9" */
  ratio?: string;
  radius?: number | string;
  /** Poster image URL; replaces the stripes */
  src?: string;
  children?: React.ReactNode;
}

export function VideoFrame({
  label,
  tone = "light",
  ratio = "16 / 9",
  radius,
  src,
  className,
  style,
  children,
  ...rest
}: VideoFrameProps): JSX.Element {
  const cls = ["gk-video", tone !== "light" && "gk-video--" + tone, className].filter(Boolean).join(" ");
  const bg = src ? { background: "center / cover no-repeat url(" + src + ")" } : null;
  return (
    <div className={cls} style={{ aspectRatio: ratio, borderRadius: radius, ...bg, ...style }} {...rest}>
      {label && !src && <span className="gk-video__label">{label}</span>}
      {children}
    </div>
  );
}
